<template>

  <ClientiInUscita />

</template>

<script>
import ClientiInUscita from '../components/pratiche/ClientiInUscita.vue'

export default {
  pageName: 'ClientiInUscita',
  components: {
    ClientiInUscita

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
